import Flickity from 'flickity';
import 'flickity-sync';
import 'flickity-fade';

const Carousel = {
  init(element = document) {
    const carousels = element.querySelectorAll('[data-carousel]');

    if (carousels.length) {
      [].forEach.call(carousels, carousel => {
        if (carousel.childElementCount > 1) {
          const carouselNav = document.querySelector(carousel.dataset.carouselNav);
          const carouselGallery = document.querySelector(carousel.dataset.carouselGallery);

          if (carouselGallery) {
            new Flickity(carouselGallery, {
              pageDots: false,
              prevNextButtons: false,
              fade: true,
              wrapAround: true,
              lazyLoad: true,
            });
          }

          const flickity = new Flickity(carousel, {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            draggable: false,
            autoPlay: 5000,
            pauseAutoPlayOnHover: false,
            pageDots: false,
            prevNextButtons: false,
            sync: carouselGallery,
          });

          if (carouselNav) {
            const carouselButtons = [...carouselNav.children];

            // update selected cellButtons
            flickity.on('select', () => {
              carouselNav.querySelector('.is-selected').classList.remove('is-selected');
              carouselButtons[flickity.selectedIndex].classList.add('is-selected');
            });

            // select cell on button click
            carouselButtons.forEach(button => {
              button.addEventListener('click', ev => {
                ev.preventDefault();

                // Select current slide
                flickity.select(carouselButtons.indexOf(button));

                // Reset autoplay
                flickity.stopPlayer();
                flickity.playPlayer();
              });
            });
          }
        }
      });
    }
  },
};

export default Carousel;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/go-adventure-blog/src/scripts/modules/carousel.js